import {CREATE_EXAM_REPORT, DELETE_EXAM_REPORT, FETCH_STUDENT_EXAM_REPORTS} from '../constants/exam-report';

export function fetchStudentExamReports() {
  return ({
    type: FETCH_STUDENT_EXAM_REPORTS,
    api: true,
    auth: true,
    payload: {
      method: 'GET',
      url: '/exams/reports'
    }
  });
}

export function createExamReport(data) {
  return ({
    type: CREATE_EXAM_REPORT,
    api: true,
    auth: true,
    payload: {
      method: 'POST',
      url: 'exams/reports',
      data
    }
  });
}

export function deleteExamReport(examReportId) {
  return ({
    type: DELETE_EXAM_REPORT,
    api: true,
    auth: true,
    payload: {
      method: 'DELETE',
      url: `exams/reports/${examReportId}`
    },
    data: {examReportId}
  });
}
